<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="17" height="17">

<rect x="0" y="0" width="7.33333" height="7.33333" />
<rect x="9" y="0" width="7.33333" height="7.33333" />
<rect x="9" y="9" width="7.33333" height="7.33333" />
<rect x="0" y="9" width="7.33333" height="7.33333" />

</svg>
</template>

<script setup lang="ts">

</script>

<style lang="scss" >

</style>